import React from 'react';
import './simple-color-picker.scss';

export const Pointer = () => {
  return <div className="tk-simple-color-picker__cursor" />;
};

export default Pointer;
